import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PartDetails } from './partdetails.model';
import { PartGroup } from '../../partgroup/partgroup.model';
import { OPCConstant } from '../../opc.const';
import { Part } from '../part.model';
import { ProductLine } from '../../productline/productline.model';
import { ColorCode } from '../colorcode.model';
import { Observable } from 'rxjs/Observable';

import * as _ from 'underscore';
import { PartService } from '../../../shared/services/part.service';
import { OPCSettings } from '../../../shared/models/opcsettings.model';
import { UserService } from '../../../shared/services/user.service';
import { size } from 'underscore';

@Component({
  selector: 'app-partdetails',
  templateUrl: 'partdetails.component.html',
  styleUrls: ['partdetails.component.css']
})

export class PartDetailsComponent implements OnInit, OnChanges {
  size: any;
  @Input() viewData: any;
  searchText: string;
  isDataLoaded: boolean;
  partGroupId: number;
  productFamilyId: number;
  defaultPart: Part;
  defaultPartClone: Part;
  parts: Part[];
  colorCodes: ColorCode[];
  allColorCodes: ColorCode[];
  productLine: ProductLine[];
  partGroup: PartGroup;
  colorItems: any;
  defaultImage: string;
  pacakageQuantitiesItems = [];
  packageType: string[];
  quantity: number[];
  handlingItems: string[];
  lengthItems: string[];
  sizeItems: string[];
  opcSettings: OPCSettings = new OPCSettings();
  blobImgURL: string;
  partPrice: any;
  serviceReimbursableItems: boolean[];
  isServiceReimbursableItems: boolean;
  pacakageQuantities: string[];
  constructor(private _partService: PartService, private _router: Router, private _route: ActivatedRoute,
    private _userService: UserService) {
    this.isDataLoaded = false;
    this.colorItems = [];
  }

  getPartDetails() {
    this.parts = this.viewData.partDTO;
    this.productLine = this.viewData.productLineDTO;
    this.partGroup = this.viewData.partGroupDTO;
    this.allColorCodes = this.viewData.colorCodeDTO;
    if (this.searchText) {
      this.defaultPartClone = this.parts.find(p => p.partNumber === this.searchText);
    } else {
      this.defaultPartClone = this.parts.find(p => p.isDefault);
    }
    if (!this.defaultPartClone) {
      this.defaultPartClone = this.parts[0];
    }
    if (!this.defaultPart || this.defaultPartClone.partID !== this.defaultPart.partID) {
      this.defaultPart = Object.assign({}, this.defaultPartClone);
      this.partPrice = this.getPrice();
      type temp = { packageType: string };
      for (let i = 0; i < this.parts.length; i++) {
        const quantity = {} as temp;
        if (this.parts[i].packageType === 'pkg' || this.parts[i].packageType === 'roll' || this.parts[i].packageType === 'pallet') {
          quantity.packageType = this.parts[i].packageType + " of " + (this.parts[i].quantity.toLocaleString('en-US'));
        }
        else {
          quantity.packageType = this.parts[i].packageType;
        }
        this.pacakageQuantitiesItems.push(quantity);
      }
      this.pacakageQuantitiesItems = this.pacakageQuantitiesItems.map(p => p.packageType).filter((value, index, self) => self.indexOf(value) === index);
      this.colorCodes = this.parts.map(p => p.colorCode).filter((value, index, self) => self.indexOf(value) === index);
      this.getColorCode();
      this.colorItems = _.uniq(this.colorCodes, _.property('colorCodeID'));
      this.handlingItems = this.parts.map(p => p.handling).filter((value, index, self) => self.indexOf(value) === index);
      this.handlingItems = this.handlingItems.filter(function (e) { return (e != 'null' && e !== null && e != ''); })
      this.handlingItems = (!this.handlingItems.length) ? undefined : this.handlingItems;
      this.lengthItems = this.parts.map(p => p.length).filter((value, index, self) => self.indexOf(value) === index);
      this.lengthItems = this.lengthItems.filter(function (e) { return (e != 'null' && e !== null && e != ''); })
      this.lengthItems = (!this.lengthItems.length) ? undefined : this.lengthItems;
      this.sizeItems = this.parts.map(p => p.size).filter((value, index, self) => self.indexOf(value) === index && value != null);
      this.sizeItems = this.sizeItems.filter(function (e) { return (e != 'null' && e !== null && e != ''); })
      this.sizeItems = (!this.sizeItems.length) ? undefined : this.sizeItems;
      var dpHandling = this.defaultPart.handling == null && this.handlingItems != null && this.handlingItems.length > 0 ? this.handlingItems[0] : this.defaultPart.handling;
      var availableSize = new Set(this.parts.filter(p => p.handling == dpHandling && p.size != null).map(ele => ele.size));
      this.sizeItems = Array.from(availableSize);
      this.sizeItems = (!this.sizeItems.length) ? null : this.sizeItems;
      this.parts.forEach(e => {
        var pkgType = this.pacakageQuantitiesItems[0].split(" ", 3);
        if (e.packageType === pkgType[0]) {
          this.isServiceReimbursableItems = e.isServiceReimbursable
        }
        this.isDataLoaded = true;
      });
    }
  }

  getColorCode() {
    this.colorCodes.forEach(e => {
      if (e.cssColorCode == null && e.code !== 'none') {
        var colorCodeList = e.code.includes('/') ? e.code.split("/") : e.colorCodeDesc.split("/");
        var colorCode1 = this.allColorCodes.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null) ? this.allColorCodes.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null).cssColorCode : 'white';
        var colorCode2 = this.allColorCodes.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null) ? this.allColorCodes.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null).cssColorCode : 'white';
        var TempcolorCode1 = colorCode1 == null ? 'white' : colorCode1;
        var TempcolorCode2 = colorCode2 == null ? 'white' : colorCode2;
        var backgroundColorCode = '-webkit-linear-gradient(-44deg,' + TempcolorCode1 + ' 49%, ' + TempcolorCode2 + ' 51%)';
        e.cssColorCode = backgroundColorCode;
      }
      else {
        var color;
        if (e.code == 'none') {
          color = '#FFFFFF';
        } else {
          color = e.cssColorCode;
        }
        var backgroundColorCode = '-webkit-linear-gradient(-44deg,' + color + ' 50%, ' + color + ' 50%)';
        e.cssColorCode = backgroundColorCode;
      }
    })

  }

  onPackageQuantityChange(event: any) {
    var pkgType = event.target.value.split(" ", 3);
    var availablePart;
    if (pkgType.length == 3) {
      availablePart = this.parts.find(p => p.packageType === pkgType[0] && p.quantity.toLocaleString('en-US') === pkgType[2].toLocaleString('en-US')
        && p.colorCode.cssColorCode === this.defaultPart.colorCode.cssColorCode
        && p.handling === this.defaultPart.handling
        && p.size === this.defaultPart.size
        && p.length === this.defaultPart.length
      );
    }
    else {
      availablePart = this.parts.find(p => p.packageType === pkgType[0]
        && p.colorCode.cssColorCode === this.defaultPart.colorCode.cssColorCode
        && (p.handling ==this.defaultPart.handling)
        && (p.size === this.defaultPart.size)
        && (p.length === this.defaultPart.length)
      );
    }
    this.parts.forEach(e => {
      if (e.packageType === pkgType[0]) {
        this.isServiceReimbursableItems = e.isServiceReimbursable
      }
    });
    this.defaultPart.packageType = pkgType[0];
    this.defaultPart.quantity = pkgType[2];

    this.getAvailablePart(availablePart);
  }
  onColorChange(event: any, i, c) {
    let hexCode = c || this.parts[i].colorCode.cssColorCode;
    //if (event.target.style.backgroundImage) {
    //  hexCode = this.rgbToHexConvert(event.target.style.backgroundImage);
    //  hexCode = hexCode.toLowerCase();
    //} else {
    //  hexCode = null;
    //}
    const availablePart = this.parts.find(p => (p.colorCode.cssColorCode ? p.colorCode.cssColorCode.toLowerCase() : null) === hexCode.toLowerCase()
      && p.colorCode.colorCodeDesc.toLowerCase() === event.target.title.toLowerCase()
      && (p.handling == this.defaultPart.handling)
      && p.packageType === this.defaultPart.packageType && (this.defaultPart.packageType != "unit" ? p.quantity.toLocaleString('en-US') === this.defaultPart.quantity.toLocaleString('en-US') : p.quantity == 1)
      && (p.size === this.defaultPart.size)
      && (p.length === this.defaultPart.length));

    this.defaultPart.colorCode = this.parts.find(p => (p.colorCode.cssColorCode
      ? p.colorCode.cssColorCode.toLowerCase() : null) === hexCode.toLowerCase()).colorCode;
    this.getAvailablePart(availablePart);
  }
  onHandlingChange(event: any) {
    var availableSize = new Set(this.parts.filter(p => p.handling === event.target.value && p.size != null).map(ele => ele.size));
    this.sizeItems = Array.from(availableSize);
    this.sizeItems = this.sizeItems.length > 0 ? this.sizeItems : null;
    this.defaultPart.handling = event.target.value;
    if (this.sizeItems != null &&
      !this.sizeItems.includes(this.defaultPart.size)) {
      this.defaultPart.size = this.sizeItems[0];
    }
    // this.defaultPart.size = this.sizeItems ? (this.sizeItems[0] == this.defaultPart.size ? this.sizeItems[0] : this.defaultPart.size): null;
    const availablePart = this.parts.find(p => p.handling === event.target.value
      && p.colorCode.cssColorCode === this.defaultPart.colorCode.cssColorCode
      && p.packageType === this.defaultPart.packageType && (this.defaultPart.packageType != "unit" ? p.quantity.toLocaleString('en-US') === this.defaultPart.quantity.toLocaleString('en-US') : p.quantity == 1)
      && p.size === (this.defaultPart.size)
      && p.length === (this.defaultPart.length));
    this.getAvailablePart(availablePart);
  }
  onLengthChange(event: any) {
    const availablePart = this.parts.find(p => p.length === event.target.value
      && p.colorCode.cssColorCode === this.defaultPart.colorCode.cssColorCode
      && p.packageType === this.defaultPart.packageType && (this.defaultPart.packageType != "unit" ? p.quantity.toLocaleString('en-US') === this.defaultPart.quantity.toLocaleString('en-US') : p.quantity == 1)
      && p.size === ( this.defaultPart.size)
      && (p.handling ==  this.defaultPart.handling));
    this.defaultPart.length = event.target.value;
    this.getAvailablePart(availablePart);
  }
  onPartLoad() {
    const availablePart = this.parts.find(p => p.size === (this.defaultPart.size != '' && (this.defaultPart.size != null || this.defaultPart.size === p.size) ? this.defaultPart.size : false)
      && p.colorCode.cssColorCode === this.defaultPart.colorCode.cssColorCode
      && p.packageType === this.defaultPart.packageType && (this.defaultPart.packageType != "unit" ? p.quantity === parseInt(this.defaultPart.quantity.toString()) : p.quantity == 1)
      && (p.handling ==  this.defaultPart.handling)
      && (p.length ===  this.defaultPart.length) &&
      p.size === (this.defaultPart.size))
    this.getAvailablePart(availablePart);
  }
  onSizeChange(event: any) {
    const availablePart = this.parts.find(p => p.size === event.target.value
      && p.colorCode.cssColorCode === this.defaultPart.colorCode.cssColorCode
      && p.packageType === this.defaultPart.packageType && (this.defaultPart.packageType != "unit" ? p.quantity.toLocaleString('en-US') === this.defaultPart.quantity.toLocaleString('en-US') : p.quantity == 1)
      && (p.handling == this.defaultPart.handling)
      && p.length === this.defaultPart.length);
    this.defaultPart.size = event.target.value;
    this.getAvailablePart(availablePart);
  }
  getAvailablePart(availablePart) {
    if (availablePart) {
      this.defaultPart = Object.assign({}, availablePart);
      this.partPrice = this.getPrice();
      this.isServiceReimbursableItems = availablePart.isServiceReimbursable;
    } else {
      this.defaultPart.partDesc = 'Not Available';
      this.defaultPart.partNumber = 'Not Available';
      this.partPrice = 'Pricing Not Available';
      this.defaultPart.notes = '';
      this.isServiceReimbursableItems = true;
    }
  }
  rgbToHexConvert(rgb: any) {
    rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    function hexConvert(x) {
      return ('0' + parseInt(x).toString(16)).slice(-2);
    }
    return '#' + hexConvert(rgb[1]) + hexConvert(rgb[2]) + hexConvert(rgb[3]);
  }
  errorImage(event) {
    //event.target.src = this.defaultImage;
  }
  getPrice(): any {
    // if (this._userService.isAdminUser()) {
    //     return this.defaultPart.partPricing.wholesalePrice;
    // } else if (this.defaultPart.partPricing.retailPrice !== null) {
    //     return this.defaultPart.partPricing.retailPrice;
    // } else {
    //     return 'Pricing not Available';
    // }      
    if (this.defaultPart.partPricing.wholesalePrice !== null && this.defaultPart.partPricing.wholesalePrice !== 0) {
      return this.defaultPart.partPricing.wholesalePrice;
    } else {
      return 'Pricing Not Available';
    }
  }
  ngOnInit() {
    this.onPartLoad();
    this.size = this.defaultPart.size;
    this._route.params.subscribe(param => {
      this.partGroupId = +param['pgid'];
      this.productFamilyId = +param['pfid'];
    });
    this._partService.searchedPart.subscribe(text => {
      this.searchText = text;
      if (this.viewData.partDTO.find(p => p.partNumber === this.searchText)) {
        this.getPartDetails();
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    this.viewData = changes.viewData.currentValue;
    this.getPartDetails();
  }
}




// WEBPACK FOOTER //
// ./src/opc/opc-app/part/partdetails/partdetails.component.ts